import React, { useMemo } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SafeComponent } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { useAppContext } from '../../context/AppContext';
import ServiceItem from '../ServiceItem';
import { getDefaultPopularServices } from './config';

interface Props {
    inExpandableSearchBar?: boolean;
}

const PopularServices = ({ inExpandableSearchBar = false }: Props) => {
    const { inCheetahsBookPublishing } = useAppContext();
    const popularServices = useMemo(
        () => getDefaultPopularServices(inCheetahsBookPublishing),
        [inCheetahsBookPublishing]
    );

    return (
        <Container width="100%" maxWidth="100%">
            {inExpandableSearchBar && (
                <Container color="white" marginTop="2" marginBottom="4" width="max-content">
                    <Text color="white">
                        <I18n k="logged_out_homepage.video_top_banner.browse_popular_categories" />
                    </Text>
                </Container>
            )}
            <Stack
                direction="row"
                gap="4"
                wrap={{ default: 'nowrap', sm: 'wrap' }}
                overflow="auto"
                justifyContent="flexStart"
                width="100%"
            >
                {popularServices.map(({ elementName, labelKey, href, eventName, isNew, onClick }, index) => (
                    <ServiceItem
                        key={elementName}
                        elementName={elementName}
                        labelKey={labelKey}
                        href={href}
                        eventName={eventName}
                        index={index}
                        isNew={isNew}
                        onClick={onClick}
                    />
                ))}
            </Stack>
        </Container>
    );
};

export default SafeComponent(PopularServices);
